<div
  class="__wrap"
  [class.has-filters]="showFilters()"
  [class.no-load-more]="!state.showLoadMore"
  [style.height]="scrollHeight()">

  <div class="__filters" *ngIf="showFilters()">
    <zef-scrollbar [height]="'51px'" class="__filter-scrollbar">

      <!-- services filter -->
      @if (services()?.length) {
        <div class="__filter-item">

          <button
            (click)="servicesPopRef.open()"
            [satPopoverAnchor]="servicesPopRef"
            mat-flat-button
            class="c-button--smaller  __filter-button">
            <mat-icon class="fx:align-middle  __filter-item_icon" fontSet="material-icons-outlined">lan</mat-icon>
            <span
              [class.is-empty]="!state.params?.serviceStackId"
              [class.is-deleted]="!!state.params?.serviceStackId && !servicesMap()?.[state.params?.serviceStackId]?.name"
              class="__select-value">
              {{
                state.params?.serviceStackId && servicesMap()?.[state.params?.serviceStackId]?.name
                  ? servicesMap()?.[state.params?.serviceStackId]?.name
                  : state.params?.serviceStackId
                    ? state.params?.serviceStackId
                    : 'no service selected'
              }}
              @if (!!state.params?.serviceStackId && !servicesMap()?.[state.params?.serviceStackId]?.name) {
                &nbsp;<span>(deleted)</span>
              }
            </span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>

          <sat-popover
            #servicesPopRef
            [autoFocus]="false"
            [restoreFocus]="false"
            hasBackdrop
            (backdropClicked)="servicesPopRef.close()"
            [verticalAlign]="'below'"
            [horizontalAlign]="'center'">
            <mat-card class="__filter-pop-card  z-manual-elevation  c-soft-elevation">
              <zef-scrollbar maxHeight="calc(100vh - 140px)">
                <mat-action-list class="__filter-action-list" dense>

                  <button
                    class="__filter-option"
                    (click)="filterChange.emit({ serviceStackId: undefined }); servicesPopRef.close();"
                    [class.is-active]="!state.params?.serviceStackId"
                    mat-list-item
                    type="button">
                    <zui-action-list-item
                      [mode]="'dense'"
                      [afterLabelIcon]="'close'"
                      [label]="'No service'"
                    />
                  </button>

                  @for (item of services(); track $index) {
                    <button
                      class="__filter-option"
                      (click)="filterChange.emit({ serviceStackId: item.id }); servicesPopRef.close();"
                      [class.is-active]="state.params?.serviceStackId === item.id"
                      mat-list-item
                      type="button">
                      <zui-action-list-item
                        [mode]="'dense'"
                        [label]="item.name"
                      />
                    </button>
                  }

                </mat-action-list>
              </zef-scrollbar>
            </mat-card>
          </sat-popover>

        </div>
      }
      <!-- container filter -->
      @if (containers?.length) {
        <div class="__filter-item">

          <button
            (click)="containerPopRef.open()"
            [satPopoverAnchor]="containerPopRef"
            mat-flat-button
            class="c-button--smaller  __filter-button">
            <mat-icon class="fx:align-middle  __filter-item_icon" fontSet="material-icons-outlined">dns</mat-icon>
            <span>{{ containerMap[state.params?.containerId]?.hostname }}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>

          <sat-popover
            #containerPopRef
            [autoFocus]="false"
            [restoreFocus]="false"
            hasBackdrop
            (backdropClicked)="containerPopRef.close()"
            [verticalAlign]="'below'"
            [horizontalAlign]="'center'">
            <mat-card class="__filter-pop-card  z-manual-elevation  c-soft-elevation">
              <zef-scrollbar maxHeight="calc(100vh - 96px)">
                <mat-action-list class="__filter-action-list" dense>
                  <button
                    class="__filter-option"
                    (click)="filterChange.emit({ containerId: item.id }); containerPopRef.close();"
                    *ngFor="let item of containers; trackBy: trackByIndex;"
                    [class.is-active]="state.params?.containerId === item.id"
                    mat-list-item
                    type="button">
                    <zui-action-list-item
                      [mode]="'dense'"
                      [label]="item.hostname"
                    />
                  </button>
                </mat-action-list>
              </zef-scrollbar>

            </mat-card>
          </sat-popover>

        </div>
      }

      @if (services()?.length || containers?.length) {
        <zui-separator
          class="__filter-item_sep"
          [size]="'small'"
          [spacing]="'none'"
          [orientation]="'horizontal'"
        />
      }

      <!-- search -->
      <div class="__filter-item  __search-item">

        @if (!!state.params?.content) {
          <button
            class="__search-item_reset-button"
            type="button"
            (click)="filterChange.emit({ content: undefined });"
            mat-icon-button>
            <mat-icon class="__search-item_reset-icon">close</mat-icon>
          </button>
        }

        <button
          type="button"
          (click)="searchPopRef.open()"
          [satPopoverAnchor]="searchPopRef"
          mat-flat-button
          class="c-button--smaller  __filter-button"
          [class.is-active]="!!state.params?.content"
        >
          <mat-icon
            class="fx:align-middle  __filter-item_icon"
            fontSet="material-icons-outlined">
            <span>search</span>
          </mat-icon>

          <span>Search</span>

          <mat-icon>keyboard_arrow_down</mat-icon>

        </button>

        <sat-popover
          #searchPopRef
          [autoFocus]="false"
          [restoreFocus]="false"
          hasBackdrop
          (backdropClicked)="searchPopRef.close()"
          (afterOpen)="searchInputRef.focus()"
          [verticalAlign]="'below'"
          [horizontalAlign]="'center'">
          <mat-card class="__search-pop-card  z-manual-elevation  c-soft-elevation">

            <zef-form (submit)="onSearch$.next(searchInputRef.value); searchPopRef.close();">

              <mat-form-field color="accent" class="__search-form-field">
                <input
                  #searchInputRef
                  matInput
                  type="text"
                  [value]="state.params?.content || ''"
                  placeholder="Search for.."
                />
              </mat-form-field>

              <button
                type="submit"
                class="c-button--full"
                color="accent"
                mat-flat-button>
                <mat-icon>search</mat-icon>&nbsp;<span>Apply search</span>
              </button>

            </zef-form>

            @if (showSearchInfoBox()) {
              <zui-separator
                class="__filter-item_sep"
                size="mini"
                spacing="small"
                orientation="vertical"
              />

              <zui-tip-card theme="tip" [icon]="null">
                <p>Please combine search with reasonable date or items range for quick and efficient query results.</p>
                <p>For a&nbsp;proper search experience over a&nbsp;large number of logs, consider setting up <a [routerLink]="projectDetailLink()" target="_blank" rel="noreferrer noopener">log&nbsp;forwarding</a> to a&nbsp;specialized log tools like Better&nbsp;Stack, Papertrail or self-hosted Logstash (which we offer as a&nbsp;one-click service).</p>
              </zui-tip-card>
            }

          </mat-card>
        </sat-popover>

      </div>

      <zui-separator
        class="__filter-item_sep"
        size="small"
        spacing="none"
        orientation="horizontal"
      />

      <ng-template [ngIf]="[
        serviceStackTypes.PhpNginx,
        serviceStackTypes.PhpApache
      ].includes(serviceStack()?.serviceStackTypeId)">

        <!-- source type -->
        <div class="__filter-item">

          <button
            mat-flat-button
            (click)="sourcePopRef.open()"
            [satPopoverAnchor]="sourcePopRef"
            class="c-button--smaller  __filter-button">
            <mat-icon class="fx:align-middle  __filter-item_icon" fontSet="material-icons-outlined">call_split</mat-icon>

            <ng-container *ngIf="!state.params?.source">
              Access Logs + PHP Logs
            </ng-container>

            <ng-container *ngIf="state.params?.source === 'access-logs'">
              Access Logs
            </ng-container>

            <ng-container *ngIf="state.params?.source === 'logs'">
              PHP Logs
            </ng-container>

            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>

          <sat-popover
            #sourcePopRef
            [autoFocus]="false"
            [restoreFocus]="false"
            hasBackdrop
            (backdropClicked)="sourcePopRef.close()"
            [verticalAlign]="'below'"
            [horizontalAlign]="'center'">
            <mat-card class="__filter-pop-card  z-manual-elevation  c-soft-elevation">

              <mat-action-list class="__filter-action-list" dense>
                <button
                  class="__filter-option"
                  [class.is-active]="!state.params?.source"
                  (click)="filterChange.emit({ source: undefined }); sourcePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="'Access Logs + PHP Logs'"
                  />
                </button>
              </mat-action-list>

              <mat-action-list class="__filter-action-list" dense>
                <button
                  class="__filter-option"
                  [class.is-active]="!state.params?.source === 'access-logs'"
                  (click)="filterChange.emit({ source: 'access-logs' }); sourcePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="'Access Logs'"
                  />
                </button>
              </mat-action-list>

              <mat-action-list class="__filter-action-list" dense>
                <button
                  class="__filter-option"
                  [class.is-active]="!state.params?.source === 'logs'"
                  (click)="filterChange.emit({ source: 'logs' }); sourcePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="'PHP Logs'"
                  />
                </button>
              </mat-action-list>

            </mat-card>
          </sat-popover>

        </div>

      </ng-template>

      <!-- severity filter -->
      <div class="__filter-item">

        <button
          mat-flat-button
          (click)="severityPopRef.open()"
          [satPopoverAnchor]="severityPopRef"
          class="c-button--smaller  __filter-button">
          <mat-icon class="fx:align-middle  __filter-item_icon" fontSet="material-icons-outlined">outlined_flag</mat-icon>
          <span><strong>{{ severitiesMap[state.params.minimumSeverity]?.name }}</strong></span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <sat-popover
          #severityPopRef
          [autoFocus]="false"
          [restoreFocus]="false"
          hasBackdrop
          (backdropClicked)="severityPopRef.close()"
          [verticalAlign]="'below'"
          [horizontalAlign]="'center'">
          <mat-card class="__filter-pop-card  z-manual-elevation  c-soft-elevation">
            <mat-action-list class="__filter-action-list" dense>
              <button
                class="__filter-option"
                *ngFor="let item of severities; trackBy: trackByIndex;"
                [class.is-active]="state.params?.minimumSeverity === item.value"
                (click)="filterChange.emit({ minimumSeverity: item.value }); severityPopRef.close();"
                mat-list-item
                type="button">
                <zui-action-list-item
                  [mode]="'dense'"
                  [label]="item.name + ' (' + item.value + ')'"
                />
              </button>
            </mat-action-list>
          </mat-card>
        </sat-popover>

      </div>

      <!-- range filter -->
      <div class="__filter-item">

        <button
          mat-flat-button
          (click)="onTimePopRefOpen(state.params?.mode); timePopRef.open()"
          [satPopoverAnchor]="timePopRef"
          class="c-button--smaller  __filter-button">
          <mat-icon class="fx:align-middle  __filter-item_icon" fontSet="material-icons-outlined">date_range</mat-icon>

          <!-- tail -->
          <span *ngIf="state.params?.mode === 'tail'">Tail Log <span *ngIf="state.itemsLength && !state.isLive">(paused)</span></span>

          <!-- range -->
          <span *ngIf="state.params?.mode === 'range'">
            Custom Range <span class="__filter-button_more-info">{{ state.params?.from | date: 'short' }} — {{ state.params?.till | date: 'short' }}</span>
          </span>

          <!-- limit -->
          <span *ngIf="state.params?.mode === 'limit'">
            Last
            <ng-container [ngSwitch]="state.params?.limit.toString()">
              <span *ngSwitchCase="'1000'">1000 {{ state.itemsLength > 1000 ? ('(+' + (state.itemsLength - 1000) + ')') : ''}}</span>
              <span *ngSwitchCase="'5000'">5000 {{ state.itemsLength > 5000 ? ('(+' + (state.itemsLength - 5000) + ')') : ''}}</span>
              <span *ngSwitchCase="'10000'">10000 {{ state.itemsLength > 10000 ? ('(+' + (state.itemsLength - 10000) + ')') : ''}}</span>
              <span *ngSwitchDefault>1000 {{ state.itemsLength > 1000 ? ('(+' + (state.itemsLength - 1000) + ')') : ''}}</span>
            </ng-container>
            Logs
          </span>

          <!-- relative period -->
          <span *ngIf="state.params?.mode === 'relPeriod'">
            {{ periodsMap.relative[state.params.period]?.name }}
          </span>

          <!-- absolute period -->
          <span *ngIf="state.params?.mode === 'absPeriod'">
            {{ periodsMap.absolute[state.params.period]?.name }}
          </span>

          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <sat-popover
          #timeRangePopRef
          [autoFocus]="false"
          [restoreFocus]="false"
          [verticalAlign]="'start'"
          [horizontalAlign]="'after'">
          <mat-card class="__time-range-card" *ngIf="!!customRangeMode">

            <zef-form>

              <zef-form-field class="__time-range-form-field">
                <mat-form-field [color]="'accent'">

                  <mat-label>From</mat-label>

                  <mat-datetimepicker-toggle [for]="fromDatetimePickerRef" matSuffix />

                  <mat-datetimepicker
                    #fromDatetimePickerRef
                    type="datetime"
                    timeInterval="1"
                  />

                  <input
                    [formControl]="rangeControl.get('from')"
                    matInput
                    [matDatetimepicker]="fromDatetimePickerRef"
                    required
                    placeholder="Select From date & time.."
                    autocomplete="false"
                  />

                </mat-form-field>
              </zef-form-field>

              <zef-form-field class="__time-range-form-field">
                <mat-form-field [color]="'accent'">

                  <mat-label>Till</mat-label>

                  <mat-datetimepicker-toggle [for]="tillDatetimePickerRef" matSuffix />

                  <mat-datetimepicker
                    #tillDatetimePickerRef
                    type="datetime"
                    timeInterval="1"
                  />

                  <input
                    [formControl]="rangeControl.get('till')"
                    matInput
                    [matDatetimepicker]="tillDatetimePickerRef"
                    required
                    placeholder="Select Till date & time.."
                    autocomplete="false"
                  />

                </mat-form-field>
              </zef-form-field>

            </zef-form>

            <button
              (click)="applyCustomRange();"
              color="accent"
              class="c-button--full"
              mat-flat-button>
              Apply custom range
            </button>

          </mat-card>

        </sat-popover>

        <sat-popover
          #timePopRef
          [autoFocus]="false"
          [restoreFocus]="false"
          hasBackdrop
          (closed)="
            customRangeMode = false;
            timeRangePopAnchorRef.popover.close()
          "
          (backdropClicked)="timePopRef.close()"
          [verticalAlign]="'below'"
          [horizontalAlign]="'center'">
          <mat-card class="__filter-pop-card  z-manual-elevation  c-soft-elevation">
            <zef-scrollbar maxHeight="calc(100vh - 96px)">
              <mat-action-list class="__filter-action-list" dense>

                <!-- tail -->
                <button
                  class="__filter-option"
                  [class.is-active]="state.params?.mode === 'tail'"
                  (click)="filterChange.emit({
                    mode: 'tail',
                    from: null,
                    till: null,
                    limit: null,
                    period: null
                  }); timePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [afterLabelIcon]="'play_arrow'"
                    [label]="'Tail Log'"
                  />
                </button>

                <!-- custom range -->
                <button
                  #timeRangePopAnchorRef="satPopoverAnchor"
                  class="__filter-option"
                  [class.is-active]="state.params?.mode === 'range'"
                  [class.is-opened]="customRangeMode === true"
                  [satPopoverAnchor]="timeRangePopRef"
                  (click)="onTimeRangePopOpen()"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [afterLabelIcon]="'date_range'"
                    [label]="'Custom range'"
                  />
                </button>

                <div mat-subheader>Relative</div>

                <!-- last x -->
                <button
                  class="__filter-option"
                  [class.is-active]="state.params?.mode === 'limit' && state.params?.limit === 1000"
                  (click)="filterChange.emit({
                    mode: 'limit',
                    limit: '1000',
                    period: null,
                    from: null,
                    till: null
                  }); timePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="'Last 1000 logs'"
                  />
                </button>

                <button
                  class="__filter-option"
                  [class.is-active]="state.params?.mode === 'limit' && state.params?.limit === 5000"
                  (click)="filterChange.emit({
                    mode: 'limit',
                    limit: '5000',
                    period: null,
                    from: null,
                    till: null
                  }); timePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="'Last 5000 logs'"
                  />
                </button>

                <button
                  class="__filter-option"
                  [class.is-active]="state.params?.mode === 'limit' && state.params?.limit === 10000"
                  (click)="filterChange.emit({
                    mode: 'limit',
                    limit: '10000',
                    period: null,
                    from: null,
                    till: null
                  }); timePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="'Last 10000 logs'"
                  />
                </button>

                <!-- relative period -->
                <button
                  *ngFor="let item of periods.relative; trackByIndex"
                  class="__filter-option"
                  [class.is-active]="state.params?.mode === 'relPeriod' && state.params?.period === item.key"
                  (click)="filterChange.emit({
                    mode: 'relPeriod',
                    period: item.key,
                    from: null,
                    till: null,
                    limit: null
                  }); timePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="item.name"
                  />
                </button>

                <div mat-subheader>Absolute</div>

                <!-- absolute period -->
                <button
                  *ngFor="let item of periods.absolute; trackByIndex"
                  [class.is-active]="state.params?.mode === 'absPeriod' && state.params?.period === item.key"
                  class="__filter-option"
                  (click)="filterChange.emit({
                    mode: 'absPeriod',
                    period: item.key,
                    from: null,
                    till: null,
                    limit: null
                  }); timePopRef.close();"
                  mat-list-item
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [label]="item.name"
                  />
                </button>

              </mat-action-list>
            </zef-scrollbar>
          </mat-card>
        </sat-popover>

      </div>

      <!-- tag filter -->
      <div class="__filter-item" *ngIf="state.logTags">

        <button
          mat-flat-button
          (click)="tagPopRef.open()"
          [satPopoverAnchor]="tagPopRef"
          class="c-button--smaller  __filter-button">
          <mat-icon class="fx:align-middle  __filter-item_icon" fontSet="material-icons-outlined">sell</mat-icon>
          <span><strong>{{ state.tagsParamsInfo ? state.tagsParamsInfo : 'All tags' }}</strong></span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <sat-popover
          #tagPopRef
          [autoFocus]="false"
          [restoreFocus]="false"
          hasBackdrop
          (backdropClicked)="tagPopRef.close()"
          [verticalAlign]="'below'"
          [horizontalAlign]="'center'">
          <mat-card class="__filter-pop-card  z-manual-elevation  c-soft-elevation">
            <zef-scrollbar maxHeight="calc(100vh - 96px)">
              <mat-action-list class="__filter-action-list" dense>

                <button
                  class="__filter-option"
                  mat-list-item
                  [class.is-active]="!state.params.tags"
                  (click)="filterChange.emit({ tags: undefined }); tagPopRef.close();"
                  type="button">
                  <zui-action-list-item
                    [mode]="'dense'"
                    [iconFaded]="false"
                    [forceIconSize]="20"
                    [iconLineHeight]="20"
                    [icon]="'done_all'"
                    [label]="'Show all tags'"
                  />
                </button>

                @for (tag of state.logTags; track $index) {
                  <button
                    class="__filter-option  __filter-option--multiselect"
                    [class.is-active]="state.tagParamsActiveMap[tag]"
                    (click)="filterChange.emit({ tags: toggleTag(tag, state.tagParamsArr) })"
                    mat-list-item
                    type="button">
                    <zui-action-list-item
                      [mode]="'dense'"
                      [iconFaded]="false"
                      [forceIconSize]="20"
                      [iconLineHeight]="20"
                      [label]="tag"
                      [icon]="state.tagParamsActiveMap[tag]
                        ? 'check_box'
                        : 'check_box_outline_blank'"
                    />
                  </button>
                }

              </mat-action-list>
            </zef-scrollbar>
          </mat-card>
        </sat-popover>

      </div>

      @if (state.hasMainTag) {
        <zui-separator size="mini" spacing="mini" orientation="horizontal" />

        <div class="__filter-item">
          <button
            mat-flat-button
            type="button"
            class="c-button--smaller __app-log-button"
            (click)="filterChange.emit({ tags: zeropsTagName })"
          >
            <span>Select zerops.yml commands tag</span>
            <span class="__tag-name">({{ zeropsTagName }})</span>
          </button>
        </div>
      }

      @if (showVictoriaSwitch()) {
        <div class="__filter-item __victoria-item">
          <button
            mat-flat-button
            type="button"
            class="c-button--smaller  __filter-button  __victoria-switch"
            [class.is-active]="victoriaActive()"
            (click)="openVictoria.emit()">
            <mat-icon class="fx:align-middle __filter-item_icon" fontSet="material-icons-outlined">analytics</mat-icon>
            <span>{{ victoriaActive() ? 'Embedded VictoriaLogs UI' : 'Open embedded VictoriaLogs UI' }}</span>
          </button>
        </div>
      }

      <!-- more options -->
      <zui-more-button
        class="__more-options"
        [popRef]="moreOptions">
      </zui-more-button>

    </zef-scrollbar>
  </div>

  <sat-popover
    #moreOptions
    [autoFocus]="false"
    [restoreFocus]="false"
    [verticalAlign]="'center'"
    [horizontalAlign]="'before'"
    scrollStrategy="close"
    hasBackdrop
    (backdropClicked)="moreOptions.close()">

    <mat-card class="__more-card  z-manual-elevation  c-soft-elevation">
      <div>

        <h5 class="__options-category-title">Options</h5>

        <button
          mat-button
          class="__menu-copy-paste-button c-button--smaller"
          (click)="setCopyPasteOnlyBaseContentMode(!activeCopyPasteOnlyBaseContentMode)"
          type="button">
          <mat-icon fontSet="material-icons-outlined">{{ activeCopyPasteOnlyBaseContentMode ? 'content_copy' : 'difference' }}</mat-icon>&nbsp;
          {{ !activeCopyPasteOnlyBaseContentMode ? 'Hide timestamps' : 'Show timestamps' }}
        </button>

        <h5 class="__actions-category-title">Actions</h5>

        <mat-nav-list>
          <a
            class="__menu-mat-list-item"
            (click)="onOpenTabLogs$.next(formatOptions.RAW); moreOptions.close();"
            mat-list-item>
            <zui-action-list-item
              class="__menu-list-item"
              icon="text_snippet"
              label="Open as plain logs">
            </zui-action-list-item>
          </a>
          <a
            class="__menu-mat-list-item"
            (click)="onOpenTabLogs$.next(formatOptions.RFC_3164); moreOptions.close();"
            mat-list-item>
            <zui-action-list-item
              class="__menu-list-item"
              icon="text_snippet"
              label="Open as RFC 3164 logs">
            </zui-action-list-item>
          </a>
          <a
            class="__menu-mat-list-item"
            (click)="onOpenTabLogs$.next(formatOptions.RFC_5424); moreOptions.close();"
            mat-list-item>
            <zui-action-list-item
              class="__menu-list-item"
              icon="text_snippet"
              label="Open as RFC 5424 logs">
            </zui-action-list-item>
          </a>
        </mat-nav-list>

      </div>
    </mat-card>

  </sat-popover>

  <div class="__log-viewport" #viewportRef [class.is-victoria-active]="victoriaActive()">

    <ng-container *ngIf="!!viewportWidth">

      <zef-scrollbar
        [height]="scrollHeight()"
        theme="os-theme-virtual-scrolling"
        [virtualScrollKey]="virtualScrollKey()">
        <div
          class="__log-scroll-el"
          data-overlayscrollbars-initialize
          rxVirtualScrollElement
          (copy)="clipboardCopy($event)">

          <div class="__load-more-wrap" *ngIf="state.showLoadMore || showFilters()">
            <zef-button-progress
              class="__load-more-progress"
              [class.is-active]="state.delayedShow"
              [active]="state.isLoadMoreLoading"
              *ngIf="state.showLoadMore && !!state.itemsLength">
              <button
                class="c-button--smaller  __load-more-button"
                mat-stroked-button
                [disabled]="state.isLoadMoreLoading"
                (click)="loadMore()">
                <mat-icon>keyboard_arrow_up</mat-icon>&nbsp;<span>Load more</span>
              </button>
            </zef-button-progress>
          </div>

          <zui-three-dots *ngIf="state.isLoading" class="__loading"></zui-three-dots>

          <rx-virtual-scroll-viewport
            class="__scroller"
            [class.is-active]="state.delayedShow"
            [dynamic]="dynamicSize"
            (scrolledIndexChange)="scrollIndexChange$.next($event)">
            <div class="__item" *rxVirtualFor="let item of items$; trackBy: 'id'; renderCallback: itemsRendered$">
              <span
                [class.has-severity-emergency]="item.severity === 0"
                [class.has-severity-alert]="item.severity === 1"
                [class.has-severity-critical]="item.severity === 2"
                [class.has-severity-error]="item.severity === 3"
                [class.has-severity-warning]="item.severity === 4"
                [class.has-severity-notice]="item.severity === 5"
                [class.has-severity-informational]="item.severity === 6"
                [class.has-severity-debug]="item.severity === 7"
                class="__severity"></span>@if (!activeCopyPasteOnlyBaseContentMode) {<span class="__timestamp">{{ item.timestamp }}</span>}@if (showHostname()) {@if (!activeCopyPasteOnlyBaseContentMode) {&nbsp;}<span class="__hostname"><span>[</span>{{ item.hostname }}<span>]</span></span>}<span class="__content">{{ item.content }}</span>
            </div>
          </rx-virtual-scroll-viewport>

        </div>
      </zef-scrollbar>

    </ng-container>

  </div>

  <div class="__options-controls" *ngIf="!!state.itemsLength && !victoriaActive()">

    <button
      class="c-button--smaller __tail-button"
      (click)="setLive()"
      type="button"
      *ngIf="!state.isLive && !!state.options?.live"
      mat-flat-button>
      <span>Start Tailing Log</span>&nbsp;<mat-icon fontSet="material-icons-outlined">play_arrow</mat-icon>
    </button>

    <button
      class="c-button--smaller  __tail-button"
      (click)="setFollow(true)"
      type="button"
      *ngIf="state.isLive && !!state.options?.live && !state.isFollowing"
      mat-flat-button>
      <mat-icon fontSet="material-icons-outlined">arrow_downward</mat-icon>&nbsp;<span>Follow Live Log</span>
    </button>

    <div class="__scroll-buttons">

      <button
        class="__scroll-button"
        (click)="setFollow()"
        *ngIf="!state.isLive"
        mat-icon-button>
        <mat-icon>arrow_downward</mat-icon>
      </button>

      <button
        class="__scroll-button"
        (click)="toTop()"
        *ngIf="!state.isLive || (state.isLive && !state.isLiveCancellable)"
        mat-icon-button>
        <mat-icon>arrow_upward</mat-icon>
      </button>

    </div>

  </div>

</div>
